import {
  LOADING_ARRAY,
  SAVE_TIMESERIES_RESPONSE,
  LIST_UNIT_TIMESERIES_REQUEST,
  LIST_UNIT_TIMESERIES_RESPONSE,
  LOGOUT_RESPONSE,
} from '../constants'

// unitId -> [timeseriesId, ...]
const initialState = {}

export default function update(state = initialState, action) {
  switch (action.type) {
    case SAVE_TIMESERIES_RESPONSE: {
      const ts = action.timeseries
      return {
        ...state,
        [ts.unit_id]: [...new Set(state[ts.unit_id]).add(ts.id)],
      }
    }

    case LIST_UNIT_TIMESERIES_REQUEST: {
      return {
        ...state,
        [action.unitId]: state[action.unitId] || LOADING_ARRAY,
      }
    }

    case LIST_UNIT_TIMESERIES_RESPONSE: {
      const s = {
        ...state,
        [action.unitId]: (action.timeseries || []).map((ts) => ts.id),
      }
      return s
    }

    case LOGOUT_RESPONSE:
      return initialState

    default:
      return state
  }
}
